<template>
  <popup @codd_close="$emit('close')">
    <div v-if="!send">

    <span class="title">{{ $t('cylinder.quotationPopup.title') }}</span>
    <div class="custom-cilinder-popup">
      <div class="form-group">
        <label for="name">{{ $t('cylinder.quotationPopup.name') }}</label>
        <input type="text" id="name" name="name" v-model="username">
        <span class="error" v-if="errors['name']" v-for="error in this.errors['name']">{{error}}</span>
      </div>
      <div class="form-group" style="margin-left: 8px;">
        <label for="company">{{ $t('cylinder.quotationPopup.company') }}</label>
        <input type="text" id="company" name="company" v-model="companyName">
        <span class="error" v-if="errors['company']" v-for="error in this.errors['company']">{{error}}</span>
      </div>
      <div class="form-group">
        <label for="address">{{ $t('cylinder.quotationPopup.address') }}</label>
        <input type="text" id="address" name="address" v-model="address">
        <span class="error" v-if="errors['address']" v-for="error in this.errors['address']">{{error}}</span>
      </div>
      <div class="form-group" style="margin-left: 8px;">
        <label for="zipcode">{{ $t('cylinder.quotationPopup.zipcode') }}</label>
        <input type="text" id="zipcode" name="zipcode" v-model="zipcode">
        <span class="error" v-if="errors['zipcode']" v-for="error in this.errors['zipcode']">{{error}}</span>
      </div>
      <div class="form-group" style="margin-left: 8px;">
        <label for="street">{{ $t('cylinder.quotationPopup.city') }}</label>
        <input type="text" id="street" name="street" v-model="streetName">
        <span class="error" v-if="errors['street']" v-for="error in this.errors['street']">{{error}}</span>
      </div>
      <div class="form-group">
        <label for="phone">{{ $t('cylinder.quotationPopup.phone') }}</label>
        <input type="tel" id="phone" name="phone" v-model="phonenumber">
        <span class="error" v-if="errors['phone']" v-for="error in this.errors['phone']">{{error}}</span>
      </div>
      <div class="form-group" style="margin-left: 8px">
        <label for="email">{{ $t('cylinder.quotationPopup.email') }}</label>
        <input type="email" id="email" name="email" v-model="email">
        <span class="error" v-if="errors['email']" v-for="error in this.errors['email']">{{error}}</span>
      </div>
    </div>

    <div class="custom-cilinder-group">
      <div class="custom-cilinder-row">
        <popup-cilinder-configurator class="custom-cilinder-item" v-for="(group, key) in groups"
           :class="{'expanded': expandedGroup.includes(key)}"
           :id="key"
           :groups="groups"
           :isExpanded="expandedGroup.includes(key)"
           :key="key"
           :cilinderName="computeName(group)"
           :cilinderSubName="computeSubName(group)"
           :stroke.sync="group.stroke"
           :pistonDiameter.sync="group.pistonDiameter"
           :rodDiameter.sync="group.rodDiameter"
           :attachment1.sync="group.attachment1"
           :attachment2.sync="group.attachment2"
           :comment.sync="group.comment"
           :circuit.sync="group.circuit"
           :amount.sync="group.amount"
           :attachments="attachments"
           @expandWithId="toggleExpansion"
           @deleteConfig="deleteConfig">
        </popup-cilinder-configurator>
      </div>
      <button type="button" class="btn-add-invoice" @click="addConfiguration">{{ $t('cylinder.quotationPopup.addAnother') }}</button>
    </div>

    <button type="button" class="btn-invoice btn-success" @click.stop="submitCilinderForm">{{ $t('cylinder.quotationPopup.sendRequest') }}</button>
    </div>
    <div v-else style="padding: 40px;text-align: center;">
      <h2>{{ $t('cylinder.quotationPopup.thanks') }}</h2>
      <h4>{{ $t('cylinder.quotationPopup.contact') }}</h4>

      <button class="btn btn-primary mt-4" @click="$emit('close')">{{ $t('cylinder.quotationPopup.back') }}</button>
    </div>
  </popup>
</template>

<script>
import Popup from "./Popup";
import Dropdown from "../input/Dropdown";
import MenuItemNumber from "../step2/menu/MenuItemNumber";
import MenuItem from "../step2/menu/MenuItem";
import InputDropdown from "../input/Dropdown";
import MenuItemAmount from "@/components/step2/menu/MenuItemAmount";

import {mapGetters} from 'vuex';
import axios from 'axios';

import Label from "@/components/input/Label";
import PopupCilinderConfigurator from "@/components/popup/PopupCilinderConfigurator";

export default {
  name: "PopupInvoice",

  components: {
    PopupCilinderConfigurator,
    Label,
    MenuItemAmount,
    Popup,
    Dropdown,
    MenuItemNumber,
    MenuItem,
    InputDropdown,
  },

  data() {
    return {
      send: false,
      busy: false,
      pistonDiameterStartValue: 0,
      rodDiameterStartValue: 0,
      strokeStartValue: 0,
      errors: [],
      expandedGroup: [0],
      groups: [{
        name: '',
        circuit: 1,
        pistonDiameter: 0,
        rodDiameter: 0,
        stroke: 0,
        attachment1: 1,
        attachment2: 1,
        amount: 0,
        comment: '',
      },
      ],
      email: '',
      username: '',
      companyName: '',
      zipcode: '',
      address: '',
      streetName: '',
      phonenumber: '',
    }
  },

  computed: {
    ...mapGetters({
      selectedCilinder: 'preference/getSelectedCilinder',
      user: 'auth/getUser',
      getAttachmentById: 'cilinders/getAttachmentsById'
    }),
    attachments() {
      return this.$store.state.cilinders.attachments;
    },
    personalInfo() {
      return {
        'name': this.username,
        'email': this.email,
        'company': this.companyName,
        'zipcode': this.zipcode,
        'address': this.address,
        'street': this.streetName,
        'phone': this.phonenumber
      };
    }
  },

  methods: {
    computeName(config) {
      return config.amount + 'x ' + '' + (config.circuit === 1 ? this.$t('cylinder.quotationPopup.double') : this.$t('cylinder.quotationPopup.single')) + ' - ' +
          config.pistonDiameter + 'mm - ' + config.rodDiameter + 'mm - ' + config.stroke + 'mm - ' + this.translate(this.getAttachmentById[config.attachment1].name) + ' - ' + this.translate(this.getAttachmentById[config.attachment2].name)
    },
    computeSubName(config) {
      return config.comment;
    },
    addConfiguration() {
      let obj = {
        name: '',
        circuit: 1,
        pistonDiameter: this.pistonDiameterStartValue,
        rodDiameter: this.rodDiameterStartValue,
        stroke: this.strokeStartValue,
        attachment1: 1,
        attachment2: 1,
        amount: 0,
        comment: '',
      }
      this.expandedGroup = [];
      this.toggleExpansion(this.groups.length) //key van elke die al open was


      if (this.groups.length < 5) this.groups.push(obj);
    },
    removeConfiguration(config) {
      console.log(config.id)
    },
    isExpanded(key) {
      return this.expandedGroup.indexOf(key) !== -1;
    },
    toggleExpansion(key) {
      if (this.isExpanded(key))
        this.expandedGroup = [];
      // this.expandedGroup.splice(this.expandedGroup.indexOf(key), 1);
      else
        this.expandedGroup = [];
      this.expandedGroup.push(key);
    },
    deleteConfig(key) {
      if (this.groups.hasOwnProperty(key) && this.groups.length > 1) {
        this.groups.splice(key, 1);
      }
    },
    submitCilinderForm() {
      if (this.busy) return;
      this.busy = true;

      axios.post(process.env.VUE_APP_API_URL + 'cilinders-form', {
        'personal-info': this.personalInfo,
        'cilinders': this.groups
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-*': '*',
        }
      })
          .then(({data}) => {
            if(data.message === 'success') {
              this.send = true;
            }

            this.busy = false;
          })
          .catch(error => {
            this.errors = [];
            this.errors = error.response.data.errors;
            this.busy = false;
          });
    }
  },

  created() {
    this.username = this.user ? this.user.name : '';
    this.email = this.user ? this.user.email : '';
    this.pistonDiameterStartValue = this.$store.state.preference.cilinderOptions.pistonDiameter;
    this.rodDiameterStartValue = this.$store.state.preference.cilinderOptions.rodDiameter;
    this.strokeStartValue = this.$store.state.preference.cilinderOptions.stroke;

    this.groups[0].pistonDiameter = this.pistonDiameterStartValue
    this.groups[0].rodDiameter = this.rodDiameterStartValue
    this.groups[0].stroke = this.strokeStartValue
  }

}
</script>

<style scoped lang="scss">
.title {
  display: block;
  padding: 20px;
  font-size: 20px;
  font-family: neue-haas-grotesk-display, sans-serif;
  font-weight: 700;
}

.custom-cilinder-popup {
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .form-group {
    display: flex;
    flex-direction: column;
    flex-basis: 33%;

    &:nth-child(5) {
      flex-basis: 31%;
    }

    label {
      font-family: neue-haas-grotesk-display, sans-serif;
      font-weight: 700;
      font-size: 14px;
      display: flex;
      margin-bottom: 2px;
      position: relative;
      margin-left: 20px;
    }

    .dropdown {
      max-width: 100%;
    }

    textarea {
      padding-top: 6px;
    }

    input, textarea {
      padding-left: 8px;
    }

    input, textarea, .dropdown {
      width: 100%;
      margin-left: auto;
      margin-right: 200px;
      min-height: 40px;
      border: 2px solid #EBEBEB;
      outline: none;
      border-radius: 25px;
      padding-left: 20px;
    }

    .error {
      color: darkred;
      font-style: italic;
      text-align: center;
    }
  }
}

.custom-cilinder-group {
  padding: 15px 20px 20px;
  display: flex;
  flex-direction: column;
}

//
//  .custom-cilinder-row {
//    display: flex;
//    flex-direction: row;
//    flex-wrap: wrap;
//
//    .invoice-amount {
//      padding: 10px;
//      border: 2px solid #EBEBEB;
//      outline: none;
//      height: 40px;
//      width: 40px;
//      position: relative;
//      border-radius: 50%;
//
//      .amount {
//        position: absolute;
//        top: 25%;
//        left: 50%;
//        right: 0;
//        bottom: 0;
//        transform: translate(-50%, -50%);
//        display: flex;
//        font-size: 30px;
//        color: rgba(0, 0, 0, 0.5);
//      }
//    }
//
//    .custom-cilinder-item {
//      width: 100%;
//
//      hr {
//        border-top: 2px solid rgba(0, 0, 0, .1);
//      }
//
//      .cilinder-options {
//        width: 100%;
//        display: flex;
//        flex-direction: row;
//        flex-wrap: wrap;
//
//        .option {
//          width: 33%;
//
//          textarea {
//            min-width: 420px;
//            height: 40px;
//            border: 2px solid #EBEBEB;
//            outline: none;
//            border-radius: 25px;
//            padding-left: 8px;
//            padding-top: 8px;
//            resize: none;
//            margin-left: 8px;
//          }
//        }
//      }
//    }
//  }
//}

.radio-container {
  width: 100%;
  border-radius: 50px;
  border: 2px solid #EBEBEB;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: white;
  transition: all ease 0.3s;

  label {
    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 12px;
    margin: 0;
    border-radius: 25px;
    width: 50%;
    padding: 9px;
    user-select: none;
    font-family: neue-haas-grotesk-display, sans-serif;
  }

  input[type="radio"] {
    display: none;


    &:checked + label {
      background-color: #3DB0C7;
      color: white;
    }
  }
}

//animations
.collapse-enter-active {
  transition: all .3s ease;
}

.collapse-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.collapse-enter, .collapse-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

.btn-invoice {
  display: flex;
  border-radius: 5px;
  color: white;
  border: none;
  height: 36px;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
  width: auto;
  padding: 0 10px;
  margin-left: auto;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 14px;
  font-family: neue-haas-grotesk-display, sans-serif;
  transition: all ease 0.3s;
  letter-spacing: 0.5px;
  background-color: #71BC03;
  outline: none;

  &:hover {
    background-color: darken(#71BC03, 10%);
    color: white;
  }
}

.btn-add-invoice {
  display: flex;
  border-radius: 5px;
  color: white;
  border: none;
  height: 36px;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
  width: auto;
  padding: 0 10px;
  margin-right: auto;
  margin-bottom: 20px;
  margin-top: 10px;
  font-size: 14px;
  font-family: neue-haas-grotesk-display, sans-serif;
  transition: all ease 0.3s;
  letter-spacing: 0.5px;
  background-color: #AFAFAF;
  outline: none;

  &:hover {
    background-color: darken(#AFAFAF, 10%);
    color: white;
  }
}

</style>
